import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {IDiscoveryDates, IPriceDiscoveryModel} from '../../models/IPriceDiscoveryModel';

declare let moment: any;

@Component({
  selector: 'app-price-discovery-card',
  templateUrl: './price-discovery-card.component.html',
  styleUrls: ['./price-discovery-card.component.scss']
})
export class PriceDiscoveryCardComponent implements OnInit {
  public isCollapsed = true;
  @HostBinding('class.card') cardClass = true;
  @HostBinding('class.row') cardRowClass = false;
  @Input()
  priceDiscovery: IPriceDiscoveryModel;
  discoveryDates: IDiscoveryDates;

  constructor() {
  }

  ngOnInit() {
    this.discoveryDates = {
      HarvestPriceBeginDate: this.priceDiscovery.HarvestPriceBeginDate,
      HarvestPriceEndDate: this.priceDiscovery.HarvestPriceEndDate,
      ProjectedPriceBeginDate: this.priceDiscovery.ProjectedPriceBeginDate,
      ProjectedPriceEndDate: this.priceDiscovery.ProjectedPriceEndDate
    };
  }

  formatDate() {
    return moment(this.priceDiscovery.SalesClosingDateDisplay).format('MMM D, YYYY');
  }

  getDiscoveryClass(status: string) {
    switch (status.toLowerCase()) {
      case 'in discovery':
        return 'discovery';
      case 'released':
        return 'released';
      case 'yet to start':
        return 'to-start';
    }
  }

  getHarvestPrice(harvestPrice?) {
    return harvestPrice ? harvestPrice : 0;
  }

  generatedId() {
    const id = this.priceDiscovery.CommodityName + this.priceDiscovery.TypeName +
      this.priceDiscovery.PracticeName + this.priceDiscovery.ActuarialDate;
    return id.toLowerCase();
  }

  formatDates(dates: string) {
    if (!dates) {
      return '';
    }
    const splitDates = dates.split('-');
    const beginDate = new moment(splitDates[0]).format('MM/DD/YY');
    const endDate = new moment(splitDates[1]).format('MM/DD/YY');
    return `${beginDate} - ${endDate}`;
  }
}
